import { useQuery } from "react-query";
import EventsApiClient from "api/EventsApiClient.js";

export function useRegionEvents(regionId, payload, options) {
    return useQuery(
        ["regionEvents", payload],
        () => EventsApiClient.getRegionEvents(regionId, payload),
        options,
    );
}
